export default __webpack_public_path__ + "static/061-9e5189af77a80e492fe3d845f37a89a4.jpg";